export default "__VITE_ASSET__B$QlH232__";